import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import { withGuestSearch } from "data/guestPortalDefaults";
import { LUXURY } from "data/guestLuxuryTheme";

const items = [
  { id: "home", label: "Home", path: "/guest", icon: HomeRoundedIcon },
  { id: "services", label: "Services", path: "/guest/stay", icon: GridViewRoundedIcon },
  { id: "requests", label: "Requests", path: "/guest/requests", icon: AssignmentTurnedInRoundedIcon },
  { id: "more", label: "More", path: "/guest/help", icon: MoreHorizRoundedIcon },
];

const GuestBottomNav = ({ search }) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1200,
        px: 0,
        pb: "env(safe-area-inset-bottom)",
        bgcolor: LUXURY.forestDeep,
        borderTop: `1px solid ${LUXURY.cardBorder}`,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          display: "flex",
          maxWidth: LUXURY.maxWidth,
          mx: "auto",
          px: 0.5,
          pt: 0.55,
          pb: 0.75,
          borderRadius: 0,
          bgcolor: "transparent",
          boxShadow: "none",
        }}
      >
        {items.map((item) => {
          const Icon = item.icon;
          const active =
            item.path === "/guest"
              ? location.pathname === "/guest" || location.pathname === "/guest/"
              : item.id === "services"
                ? location.pathname.startsWith("/guest/stay") ||
                  location.pathname.startsWith("/guest/buffet") ||
                  location.pathname.startsWith("/guest/offers") ||
                  location.pathname.startsWith("/guest/housekeeping") ||
                  location.pathname.startsWith("/guest/laundry") ||
                  location.pathname.startsWith("/guest/amenities")
                : location.pathname.startsWith(item.path);
          return (
            <Box
              key={item.id}
              component="button"
              onClick={() => navigate(withGuestSearch(item.path, search))}
              sx={{
                flex: 1,
                appearance: "none",
                border: 0,
                minHeight: 54,
                borderRadius: "14px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 0.2,
                color: active ? LUXURY.gold : LUXURY.stone,
                bgcolor: "transparent",
                cursor: "pointer",
                WebkitTapHighlightColor: "transparent",
              }}
            >
              <Icon sx={{ fontSize: 22 }} />
              <Typography
                sx={{
                  fontSize: "0.62rem",
                  fontWeight: active ? 700 : 600,
                  letterSpacing: 0.2,
                  lineHeight: 1.2,
                  px: 0.25,
                  textAlign: "center",
                }}
              >
                {item.label}
              </Typography>
            </Box>
          );
        })}
      </Paper>
    </Box>
  );
};

export default GuestBottomNav;
